"use client";
import useYoloLogic from "hooks/useYolo";
import AdminNavigation from "layouts/adminNavigation";

export default function YoloManagement() {
  const {
    user,
    isNavCollapsed,
    setIsNavCollapsed,
    loading,
    error,
    detectionMode,
    setDetectionMode,
    applyMode
  } = useYoloLogic();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <>
      <AdminNavigation
        user={user}
        isCollapsed={isNavCollapsed}
        onToggleCollapse={() => setIsNavCollapsed(!isNavCollapsed)}
      />

      <div className={`transition-all duration-300 ${isNavCollapsed ? "ml-16" : "ml-64"} p-6`}>
        <div className="max-w-4xl mx-auto">

          {/* Header */}
          <div className="mb-10">
            <h1 className="text-3xl font-bold text-gray-800">
              YOLO Detection Mode
            </h1>
            <p className="text-gray-600 mt-1">
              Choose how the camera should detect people
            </p>
          </div>

          {/* Error */}
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6">
              {error}
            </div>
          )}

          {/* Mode Selector */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

            {/* PERSON ONLY */}
            <div
              onClick={() => setDetectionMode("PERSON")}
              className={`cursor-pointer rounded-xl border p-6 transition-all
                ${detectionMode === "PERSON"
                  ? "border-blue-600 bg-blue-50"
                  : "border-gray-200 hover:border-blue-400"}
              `}
            >
              <h2 className="text-xl font-semibold text-gray-800">
                Person Only
              </h2>
              <p className="text-gray-600 mt-2">
                Detect only people (no PPE validation)
              </p>
            </div>

            {/* FULL KIT */}
            <div
              onClick={() => setDetectionMode("FULL_KIT")}
              className={`cursor-pointer rounded-xl border p-6 transition-all
                ${detectionMode === "FULL_KIT"
                  ? "border-blue-600 bg-blue-50"
                  : "border-gray-200 hover:border-blue-400"}
              `}
            >
              <h2 className="text-xl font-semibold text-gray-800">
                Full PPE Kit
              </h2>
              <p className="text-gray-600 mt-2">
                Detect person only if full PPE is worn
              </p>
            </div>

          </div>

          {/* Apply Button */}
          <div className="mt-10">
            <button
              onClick={applyMode}
              className="px-8 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition"
            >
              Apply Detection Mode
            </button>
          </div>

        </div>
      </div>
    </>
  );
}